<div class="wrapper-mini text-center auth-form">
    <h1 class="header">Create Password</h1>
    <p class="margin-bottom-20">Create a password for <strong>{{ email }}</strong></p>

    <div class="form-block text-left">
        <label for="password">Password</label>
        <div class="password-input-container">
            <input [type]="showPassword ? 'text' : 'password'" name="password" data-testid="input-signup-password" [(ngModel)]="password" (ngModelChange)="validatePassword()" (keyup.enter)="completeSignup()">
            <button (click)="toggleShowPassword()" data-testid="btn-toggle-password-visibility" class="toggle-password-button">
                {{ showPassword ? 'Hide' : 'Show' }}
            </button>
        </div>
        <div class="password-requirements">
            <ul>
                <li [class.valid]="passwordRequirements.length">At least 8 characters</li>
                <li [class.valid]="passwordRequirements.uppercase">At least one uppercase letter</li>
                <li [class.valid]="passwordRequirements.lowercase">At least one lowercase letter</li>
                <li [class.valid]="passwordRequirements.number">At least one number</li>
                <li [class.valid]="passwordRequirements.special">At least one special character</li>
            </ul>
        </div>
    </div>

    <div class="form-block text-left">
        <label for="confirmPassword">Confirm Password</label>
        <div class="password-input-container">
            <input [type]="showPassword ? 'text' : 'password'" name="confirmPassword" data-testid="input-signup-confirm-password" [(ngModel)]="confirmPassword" (ngModelChange)="checkPasswordsMatch()" (keyup.enter)="completeSignup()">
            <button (click)="toggleShowPassword()" data-testid="btn-toggle-confirm-password-visibility" class="toggle-password-button">
                {{ showPassword ? 'Hide' : 'Show' }}
            </button>
        </div>
        <div class="password-requirements" *ngIf="confirmPassword.length > 0">
            <ul>
                <li [class.valid]="passwordsMatch">Passwords match</li>
            </ul>
        </div>
    </div>

    <div class="footer">
        <saffron-button text="Complete Signup"
                        data-testid="btn-complete-signup"
                        size="wide" 
                        type="primary" 
                        [is_loading]="loading"
                        [is_disabled]="!allRequirementsMet() || password !== confirmPassword"
                        (click)="completeSignup()">
        </saffron-button>
        <p>
            <a class="text-color-primary" data-testid="link-back-to-code" (click)="goBack()">Back</a>
        </p>
    </div>
</div>
